import React, { useState } from 'react';
import { Tag, message } from 'antd';
import ActionMenu from '@/components/actionmenu';
import { Link } from 'react-router-dom';
import { confirmPostCompletion, reapplyApplication, withdrawApplication } from '@/apis/posts';
import ReviewForm from '@/components/reviewform';
import { applicationReason } from '@/utils/applications';
import usePrivateAction from '@/utils/usePrivateAction';
import './index.scss';

const ApplicationActions = ({ application, publisher = false, onChanged }) => {
  const [reviewOpen, setReviewOpen] = useState(false);
  const { busy, run } = usePrivateAction();
  const actions = application.actions || {};
  const postId = application.post;
  const target = publisher ? application.applicant : application.post_owner;
  const perform = (operation, text) => run(operation, () => { message.success(text); onChanged(); });
  const specs = [
    ...(!publisher ? [
      { key: 'withdraw', label: '撤回申请', group: 'application', danger: true, operation: () => perform(() => withdrawApplication(application.id), '申请已撤回'), title: '确认撤回申请？获批申请撤回后将退出帖子群聊。' },
      { key: 'reapply', label: '重新申请', group: 'application', operation: () => perform(() => reapplyApplication(application.id), '已重新申请，请等待审批'), title: '确认重新申请？仍需发布者审批。' },
      { key: 'confirm_completion', label: '确认完成', group: 'activity', operation: () => perform(() => confirmPostCompletion(postId), '已确认活动完成'), title: '确认你已完成本次活动？' },
    ] : []),
    { key: publisher ? 'review_participant' : 'review_owner', label: publisher ? '评价参与者' : '评价发布者', group: 'activity', operation: () => setReviewOpen(true) },
  ].filter(item => actions[item.key]);
  const menuItems = group => specs.filter(item => item.group === group).map(item => {
    const hint = actions[item.key];
    return {
      key: item.key, label: item.label, danger: item.danger, disabled: !hint.available,
      disabledReason: applicationReason(hint.reason), confirm: item.title, confirmTitle: item.label,
      onClick: item.operation,
    };
  });
  const applicationItems = menuItems('application');
  const activityItems = [
    ...menuItems('activity'),
    ...(application.conversation_id ? [{ key: 'group', label: <Link to={`/message/${application.conversation_id}`}>进入帖子群聊</Link>, disabled: busy }] : []),
    ...(application.review_state?.my_review_id ? [{ key: 'reviews', label: <Link to={`/personal/reviews?post_id=${postId}`}>查看评价</Link>, disabled: busy }] : []),
  ];
  return <div className="applicationActions">
    <ActionMenu key={`application:${application.id}`} label="申请管理" items={applicationItems} disabled={busy} />
    <ActionMenu key={`activity:${application.id}`} label="活动与交流" items={activityItems} disabled={busy} />
    {application.review_state?.my_review_id && <Tag color={application.review_state.is_revealed ? 'success' : 'processing'}>{application.review_state.is_revealed ? '双方评价已揭示' : '你已评价，等待双方揭示'}</Tag>}
    <ReviewForm postId={postId} target={target} open={reviewOpen} onCancel={() => setReviewOpen(false)} onSaved={() => { setReviewOpen(false); onChanged(); }} />
  </div>;
};
export default ApplicationActions;
